<template>
  <v-select
    :options="options"
    :selectName="selectName"
    :selectId="selectId"
    :value="modelValue"
    @input="$emit('update:modelValue', $event.target.value)"
    required
  ></v-select>
</template>

<script>
import carMakesApi from "@/api/resources/carMakesApi";
import VSelect from "@/components/VSelect.vue";

export default {
  props: {
    selectName: String,
    selectId: String,
    modelValue: [String, Number],
  },
  emits: ["update:modelValue"],
  components: { VSelect },

  data() {
    return {
      options: [],
    };
  },

  methods: {
    getCarMakes() {
      carMakesApi.index().then((response) => {
        this.options = response.data.map((make) => {
          return { text: make.name, value: make.id };
        });
      });
    },
  },

  created() {
    this.getCarMakes();
  },
};
</script>

<style></style>
